import { SmartHold } from "@clockwise/schema";
import { getFormattedEventTime } from "@clockwise/web-commons/src/util/date.util";
import React from "react";
import { FocusTimeHold } from "./FocusTimeHold";
import { LunchHold } from "./LunchHold";
import { MeetingReliefHold } from "./MeetingReliefHold";
import { TravelTimeHold } from "./TravelTimeHold";

type SmartHoldEventProps = {
  smartHold: Partial<SmartHold>;
  holdId: string;
  orgId: string;
  calendarId: string;
  title: string;
};

export const SmartHoldEvent = ({
  smartHold,
  holdId,
  orgId,
  calendarId,
  title,
}: SmartHoldEventProps) => {
  const { times } = smartHold;
  const formattedEventTime = times
    ? getFormattedEventTime({ start: times.start, end: times.end })
    : "";
  const smartHoldType = smartHold.__typename;

  if (!smartHoldType) {
    return null;
  }

  switch (smartHoldType) {
    case "FocusTimeHold":
      return (
        <FocusTimeHold
          goals={smartHold.goals}
          state={smartHold.state}
          title={title}
          displayTime={formattedEventTime}
          holdId={holdId}
          orgId={orgId}
          calendarId={calendarId}
        />
      );
    case "LunchHold":
      return (
        <LunchHold
          goals={smartHold.goals}
          state={smartHold.state}
          title={title}
          displayTime={formattedEventTime}
          holdId={holdId}
          orgId={orgId}
          calendarId={calendarId}
        />
      );
    case "MeetingReliefHold":
      return (
        <MeetingReliefHold
          goals={smartHold.goals}
          state={smartHold.state}
          title={title}
          displayTime={formattedEventTime}
          holdId={holdId}
          orgId={orgId}
          calendarId={calendarId}
        />
      );
    case "TravelTimeHold":
      return (
        <TravelTimeHold
          title={title}
          holdId={holdId}
          orgId={orgId}
          calendarId={calendarId}
          times={times}
        />
      );
    default:
      return null;
  }
};
